module.exports = __webpack_public_path__ + "static/media/checkout-test-mobile.1896ac4a.png";